import { useAppSelector } from 'flow/hooks/useRedux';
import { Map } from 'immutable';

import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { Channel } from 'flow/types/Channel';
import { ChannelKey, ExtensionKey } from 'flow/types/EntityKeys';

import { TypedMap } from 'flow/types/TypedMap';

interface ChannelHook {
    channels: TypedMap<Record<ChannelKey, TypedMap<Channel>>>;
    channelNames: Map<ChannelKey, string>;
}

const useChannel = (extensionKey: ExtensionKey = null): ChannelHook => {
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    if (!extensionKey) {
        extensionKey = ownExtensionKey;
    }

    const chatUserKey = useAppSelector((state) =>
        state.extensions.getIn(['extensions', extensionKey, 'chatUserKey']),
    );

    const allChannels = useAppSelector((state) =>
        state.channels.get('channels', Map()),
    );

    const channels = allChannels.filter((channel: TypedMap<Channel>) =>
        channel
            .get('channelMemberDTOs')
            .some((member) => member.get('chatUserKey') === chatUserKey),
    );

    const channelNames = channels.map((channel) => channel.get('channelName'));

    return { channels, channelNames };
};

export default useChannel;
